import React, { useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faHouse, faCircleUser, faEarthAmericas, faRightFromBracket, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import useWindowDimensions from '../hooks/useWindowDimension';

import IconToggle from './IconToggle';
import SidebarItemLayout from '../layouts/SidebarItemLayout';

import logo from '../assets/images/Fundemas_Logo3.png';
import { getCookie } from '../utils/utils';

export default function Navbar({ isExpanded, setIsExpanded }) {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();

    useEffect(() => {
        if (width >= 768) {
            setIsExpanded(true);
        }
    }, [width]);

    const handleMenu = () => {
        if (width < 768) {  // Solo afecta a móviles
            document.body.style.overflow = isExpanded ? 'auto' : 'hidden';
            setIsExpanded(!isExpanded);
        }
    };

    const logOut = async () => {
        let session = Cookies.get("AuthToken");
        let uri = process.env.REACT_APP_API_URL + 'logout';

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': `Bearer ${session}`
            }
        };

        try {
            await axios.post(uri, {}, config);
            Cookies.remove("AuthToken");
            navigate("/");
        } catch (error) {
            Cookies.remove("AuthToken");
            navigate("/");
        }
    };

    const handleLogOut = () => {
        Swal.fire({
            title: '¿Estás seguro de cerrar sesión?',
            icon: 'warning',
            showDenyButton: true,
            confirmButtonText: `Cerrar sesión`,
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                logOut();
            }
        });
    };

    const clearStorage = () => {
        sessionStorage.clear();

        localStorage.removeItem("FormDatosTrabajador");
        localStorage.removeItem("FormHijos");
        localStorage.removeItem("FormServicio");

        navigate("/");
    };

    return (
        <>
            {/* Botón de hamburguesa para móviles */}
            <IconToggle
                clicked={isExpanded}
                className="!fixed !z-50 top-4 left-4 !bg-custom-main md:!hidden"
                onClick={handleMenu}
            />

            {/* Sidebar */}
            <div className={`h-screen fixed top-0 left-0 bg-custom-main transition-all duration-300 z-20 
                ${isExpanded ? 'w-[100px]' : 'w-[100px]'}
                md:${isExpanded ? 'w-[100px]' : 'w-[100px]'}
                ${width < 768 ? (isExpanded ? 'translate-x-0' : '-translate-x-full') : 'md:translate-x-0'}`}>

                <div className="w-full h-full flex flex-col items-center">
                    <div className="h-32 pt-4 w-full flex justify-center items-center bg-white">
                        <img src={logo} alt="Logo" className="h-12" />
                    </div>
                    <nav className="w-full h-full pt-4 flex flex-col justify-between items-center">
                        <div className="w-full">
                            <SidebarItemLayout link={getCookie() ? "/Inicio" : "/"} icon={faHouse} title="Inicio" onClick={handleMenu} />
                            <SidebarItemLayout link="/UbicacionCapis" icon={faEarthAmericas} title="Localización de centros CAPI" onClick={handleMenu} />
                            <SidebarItemLayout link="/InformacionCapis" icon={faCircleQuestion} title="Acerca del beneficio CAPI" onClick={handleMenu} />
                            {getCookie() && <SidebarItemLayout link="/PerfilUsuario" icon={faCircleUser} title="Mi perfil" onClick={handleMenu} />}
                        </div>
                        {getCookie() && (
                            <div className="w-full">
                                <div className="group relative">
                                    <button type="button" onClick={handleLogOut} className="flex items-center justify-center px-4 py-2 text-gray-100 bg-custom-cyan w-full h-20 transition-colors hover:bg-custom-cyan-hover">
                                        <FontAwesomeIcon icon={faRightFromBracket} size="2x" className="text-custom-main" />
                                    </button>
                                    {/* Tooltip */}
                                    <div className="absolute w-48 top-1/3 left-full ml-2 px-2 py-2 bg-gray-800 text-white text-sm text-center rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                        Cerrar sesión
                                        <div className="absolute top-1/2 -left-1 w-2 h-2 bg-gray-800 transform -translate-y-1/2 rotate-45"></div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!getCookie() && (
                            <div className="w-full">
                                <div className="group relative">
                                    <button type="button" onClick={clearStorage} className="flex items-center justify-center px-4 py-2 text-gray-100 bg-custom-cyan w-full h-20 transition-colors hover:bg-custom-cyan-hover">
                                        <FontAwesomeIcon icon={faRightFromBracket} size="2x" className="text-custom-main" />
                                    </button>
                                    {/* Tooltip */}
                                    <div className="absolute w-48 top-1/3 left-full ml-2 px-2 py-2 bg-gray-800 text-white text-sm text-center rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                        Salir del formulario
                                        <div className="absolute top-1/2 -left-1 w-2 h-2 bg-gray-800 transform -translate-y-1/2 rotate-45"></div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </nav>
                </div>
            </div>
        </>
    );
}